export default class Library {

    constructor() {
        this.libraryId = 0;
        this.title = "";
        this.horizontalIndex = false;
        this.verticalIndex = false;
        this.compressedResources = false;
        this.visualTemplate = null;
        this.deviceLanguageList = [];
        this.defaultLanguage = '';
        this.enableAnalytics = false;
        this.analyticsWebId = '';
        this.appUrl = '';
        this.indexSortType = '';
        this.singleIssueApp = false;
        this.expandPagesXml = false;
        this.catalogList = [];
    }

    getRecursiveCatalogList() {
        let res = [];
        res = res.concat(this.catalogList);
        this.catalogList.forEach((elem) => {
            res = res.concat(elem.getRecursiveChildList());
        });
        return res;
    }

}
